import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { TApiUserSettingValue } from '@cbridge-packages/api';
import { userSettingsStoreSelector } from '../userSettings.selector';

export const userSettingSelector = createCachedSelector(
  [
    path(userSettingsStoreSelector).settings(),
    prop<{ settingKey: string }>().settingKey(),
  ],
  // Shared components (DefaultDataGrid, the sidebar drawer) also mount in apps without the userSettings slice.
  (settings, settingKey): TApiUserSettingValue | undefined => settings?.[settingKey],
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ settingKey: string }>().settingKey(),
});
